import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice, createAction } from '@reduxjs/toolkit';
import type { TouristData } from 'src/routes/OrderChangingRequest/components/TouristsChange/TouristsChangeComponent/types';
import type { CancellationReasons, IOrder } from './types';
import { CancelRequestStatus } from './types';

export const name = 'order';

const initialState: IOrder = {
  info: {},
  cancellationReasons: {
    reasons: [],
    refundText: null,
    refundTitle: null,
    paid: false,
    refundToken: '',
  },
  cancellRequestStatus: CancelRequestStatus.UNDEFINED,
  changesRequestStatus: CancelRequestStatus.UNDEFINED,
  changes: '',
  customReasonText: '',
  changesTouristsRequestStatus: CancelRequestStatus.UNDEFINED,
  requestStatusText: '',
  requestStatusTitle: '',
};

const reducers = {
  setOrderInfo: (state: IOrder, action: PayloadAction<IOrder['info']>) => {
    state.info = action.payload;
  },
  setCancellationReasons: (
    state: IOrder,
    action: PayloadAction<CancellationReasons>,
  ) => {
    state.cancellationReasons.paid = action.payload.paid;
    state.cancellationReasons.refundText = action.payload.refundText;
    state.cancellationReasons.refundTitle = action.payload.refundTitle;
    state.cancellationReasons.refundToken = action.payload.refundToken;
    state.cancellationReasons.reasons = action.payload.reasons;
  },
  setSelectedCancelReason: (
    state: IOrder,
    action: PayloadAction<IOrder['selectedCancelReason']>,
  ) => {
    state.selectedCancelReason = action.payload;
  },
  setCancellRequestStatus: (
    state: IOrder,
    action: PayloadAction<IOrder['cancellRequestStatus']>,
  ) => {
    state.cancellRequestStatus = action.payload;
  },
  setCancellRequestText: (
    state: IOrder,
    action: PayloadAction<
      Pick<IOrder, 'requestStatusText' | 'requestStatusTitle'>
    >,
  ) => {
    const { requestStatusText, requestStatusTitle } = action.payload;
    state.requestStatusText = requestStatusText;
    state.requestStatusTitle = requestStatusTitle;
  },
  setChangesRequestStatus: (
    state: IOrder,
    action: PayloadAction<IOrder['changesRequestStatus']>,
  ) => {
    state.changesRequestStatus = action.payload;
  },
  setChanges: (state: IOrder, action: PayloadAction<IOrder['changes']>) => {
    state.changes = action.payload;
  },
  setCustomReasonText: (
    state: IOrder,
    action: PayloadAction<IOrder['customReasonText']>,
  ) => {
    state.customReasonText = action.payload;
  },
  setChangesTouristsRequestStatus: (
    state: IOrder,
    action: PayloadAction<IOrder['changesTouristsRequestStatus']>,
  ) => {
    state.changesTouristsRequestStatus = action.payload;
  },
};
const packageUpsaleOptions = createSlice({
  name,
  initialState,
  reducers,
});

export const {
  setOrderInfo,
  setCancellationReasons,
  setSelectedCancelReason,
  setCancellRequestStatus,
  setCancellRequestText,
  setChanges,
  setChangesRequestStatus,
  setCustomReasonText,
  setChangesTouristsRequestStatus,
} = packageUpsaleOptions.actions;

export const fetchOrderInfo = createAction(`${name}/fetchOrderInfo`);

export const cancellOrder = createAction(`${name}/cancellOrder`);

export const changesOrder = createAction(`${name}/changesOrder`);

export const touristChangesOrder = createAction(`${name}/touristChangesOrder`);

export const submitTouristChange = createAction<{ tourists: TouristData[] }>(
  `${name}/submitTouristChange`,
);

export const fetchCancellationReasons = createAction(
  `${name}/fetchCancellationReasons`,
);

export const resetStatusRequestAction = createAction(
  `${name}/resetStatusRequest`,
);

export default packageUpsaleOptions.reducer;
